import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IStopBreak {
  break_id: number;
  timezone: string;
}

const stopBreak = (postData: IStopBreak) => {
  return http().post(endpoints.breaks.stopBreak, postData);
};

export function useStopBreak() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: stopBreak,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['checkClockIn'] });
    },
  });
}
